import * as React from 'react';
import { cn } from '../utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'flex h-9 w-full rounded-[4px] border border-[var(--color-border)] bg-[var(--color-bg)] px-3 py-1 text-[14px] text-[var(--color-text-primary)]',
          'placeholder:text-[var(--color-text-tertiary)]',
          'transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-bg)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'file:border-0 file:bg-transparent file:text-[14px] file:font-medium file:text-[var(--color-text-primary)]',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
